<template>
  <div>
    <div id="overlay" v-if="fetchingData">
      <div class="spinner"></div>
    </div>
    <div class="row">
      <h1> Air Quality Site Request </h1>
    </div>
    <div class="row">
      <h3> Site Information</h3>
    </div>
    <div class="row">
      <div class="col">
        <base-input v-model="form.siteName"
                    label="Site Name"
                    placeholder="Site Name"
                    :validation="$v.form.siteName"/>
      </div>
    </div>
    <v-address v-model="form.ownerAddress"
           labelPrefix="Site Address"
           :validation="$v.form.ownerAddress"
           :show-unincorporated="false"/>
    <div class="row">
      <h3> Site Owner Information </h3>
    </div>
    <div class="row">
      <div class="col">
        <base-input v-model="form.owner"
                    label="Site Owner"
                    placeholder="Site Owner"
                    :validation="$v.form.owner" />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <base-input v-model="form.contactFirstName"
                    label="Site Contact First Name"
                    placeholder="First Name"
                    :validation="$v.form.contactFirstName"/>
      </div>
      <div class="col">
        <base-input v-model="form.contactLastName"
                    label="Site Contact Last Name"
                    placeholder="Last Name"
                    :validation="$v.form.contactLastName"/>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <base-input v-model="form.contactPhone"
                    label="Site Contact Phone"
                    type="tel"
                    mask="###-###-####"
                    placeholder="xxx-xxx-xxxx"
                    :validation="$v.form.contactPhone"/>
      </div>
      <div class="col">
        <base-input v-model="form.contactEmail"
                    label="Site Contact Email"
                    type="email"
                    placeholder="name@company.com"
                    :validation="$v.form.contactEmail"/>
      </div>
      <div class="col">
        <base-input v-model="form.contactTitle"
                    label="Site Contact Title"
                    placeholder="Title"
                    :validation="$v.form.contactTitle"/>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <base-input v-model="form.confirmEmail"
                    label="Confirm Site Contact Email"
                    type="email"
                    placeholder="name@company.com"
                    :validation="$v.form.confirmEmail"/>
      </div>
    </div>
    <div class="row" style="margin-top: 1%;">
      <button class="btn btn-success" @click="submit">
        Submit Request
      </button>
      <button class="btn btn-primary m-l-1" @click="back">
        Back to Site Authentication
      </button>
    </div>
  </div>
</template>

<script>
import { SiteRequest } from '~/js/FormObjects';
import { SiteRequestValidations } from '~/js/FormValidations';
import { requestSite } from '~/js/FormFunctions';
import VAddress from '~/components/VAddress';
import BaseInput from '~/components/BaseInput';

export default {
  name: 'SiteRequest',
  components: { VAddress, BaseInput },
  data() {
    return {
      form: new SiteRequest(),
      fetchingData: false,
    };
  },
  mounted() {
    const vm = this;
  },
  validations: {
    form: new SiteRequestValidations(),
  },
  methods: {
    submit() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        this.$notify('Errors requesting new site', 'Errors in field(s)');
        return;
      }
      this.fetchingData = true;
      const vm = this;
      requestSite(this.form)
        .then((res) => {
          vm.fetchingData = false;
          vm.$router.push({ name: 'SiteRequestThankYou', query: vm.$route.query });
        })
        .catch((error) => {

        });
    },
    back() {
      this.$router.push({ name: 'SiteAuthentication', query: this.$route.query });
    },
  },
};
</script>
